import { axiosInstance } from '../axios';

import { TableResultType } from '@/shared/types/api.type';
import {
  BankruptSearchFileDownloadRequest,
  BankruptSearchFileDownloadResponse,
  BankruptSearchFileManagementType,
  BankruptSearchFileUploadRequest,
  BankruptSearchFileUploadResponse,
  BankruptSearchResultModel,
  GetBankruptSearchFileManagementListRequest,
  GetBankruptSearchResultListRequest,
} from '@/shared/types/api/api.bankruptSearch';

export const getBankruptSearchResultList = async ({
  groupId,
  pageIndex,
  pageSize,
  bankruptSearchExecutionHistoryId,
}: GetBankruptSearchResultListRequest): Promise<TableResultType<BankruptSearchResultModel[]>> => {
  const { data } = await axiosInstance.get<TableResultType<BankruptSearchResultModel[]>>(
    `/group/${groupId}/execution/${bankruptSearchExecutionHistoryId}/bankrupt-search/list`,
    {
      params: {
        offset: (pageIndex - 1) * pageSize,
        limit: pageSize,
      },
    },
  );
  return data;
};

export const getBankruptSearchFileUploadList = async ({
  groupId,
  pageIndex,
  pageSize,
  customerId,
}: GetBankruptSearchFileManagementListRequest): Promise<
  TableResultType<BankruptSearchFileManagementType[]>
> => {
  const { data } = await axiosInstance.get<TableResultType<BankruptSearchFileManagementType[]>>(
    `/group/${groupId}/customer/${customerId}/bankrupt-search/file-list`,
    {
      params: {
        offset: (pageIndex - 1) * pageSize,
        limit: pageSize,
      },
    },
  );
  return data;
};

export const bankruptSearchFileUpload = async ({
  groupId,
  customerId,
  fileName,
  fileExtension,
  fileSize,
}: BankruptSearchFileUploadRequest): Promise<BankruptSearchFileUploadResponse> => {
  const { data } = await axiosInstance.post<BankruptSearchFileUploadResponse>(
    `/group/${groupId}/customer/${customerId}/bankrupt-search/file-upload`,
    {
      fileName,
      fileExtension,
      fileSize,
    },
  );
  return data;
};

export const bankruptSearchFileDownload = async ({
  groupId,
  bankruptSearchFileManagementId,
}: BankruptSearchFileDownloadRequest): Promise<BankruptSearchFileDownloadResponse> => {
  const { data } = await axiosInstance.get<BankruptSearchFileDownloadResponse>(
    `/group/${groupId}/bankrupt-search-file-management/${bankruptSearchFileManagementId}/file-download`,
  );
  return data;
};
